// The result of a Euclidean modulus is always positive.
export default function euclideanModulus(num, mod) {
  var remain = num % mod;
  return remain >= 0 ? remain : remain + mod;
}